module.exports = {
    DELETE_ATTACHMENT: "Are you sure you want to delete this attachment?",
    DELETE_TASK: "Are you sure you want to delete this task?",
    DELETE_TASK_COMMENT: "Are you sure you want to delete this comment?",
    DELETE_FAVOURITETASK: "Are you sure you want to remove this task as favorite?",
    TASK_BULK_ACTION: "Are you sure you want to perform this action?",
    BILLABLE_HOURS_INFO_MSG: "How many hours you worked in this task add those hours here.",
    DEV_HOURS_INFO_MSG: "How many hours developer worked in this task add those hours here.",
    BUCKET_HOURS_INFO_MSG: "How many hours developer worked in this task add those hours here.",
    ASSIGNEDTO_MSG: "Users who are members of this project can only be assigned ",
    BILLABLE_HOURS_VALIDATE_MSG: "Invalid billable hours. Please enter a valid hours.",
    LOGGED_DEV_HOURS_VALIDATE_MSG: "Invalid dev hours. Please enter a valid hours.",
    LOGGED_BUCKET_HOURS_VALIDATE_MSG: "Invalid bucket hours. Please enter a valid hours.",
    COPY_LINK_MSG: "Link copied successfully"
}